import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import ModalRoutes from '../ModalRoutes';
import ReactTooltip from 'react-tooltip';
import axios from "axios";
import { debounce } from "lodash";
import moment from "moment";

import Navbar from '../../Navbar';

import { LoadingIcon, LoadingIconRow } from '../../Common/Loading_Icon';
import { checkCredentials } from '../../../Helpers/checkCredentials.js';

class SHReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_data: true,
            data: {}
        };
    }

    componentDidMount() {
        document.title = "Stakeholder Reports - FleetXPress"

        var self = this;

        $('body').unbind('click'); // unbind any click event listners previously created
        $('body').on('click', function(e) {
            if($('.dropdown-pane.is-open').length > 0 && (!$(e.target).hasClass('dropdown') && !$(e.target).hasClass('fa-filter') && !$(e.target).hasClass('table-header-text')) && $(e.target).parents('.dropdown-pane.is-open').length == 0) {
                $('.dropdown-pane.is-open').removeClass('is-open');
                $('.table-header-text.primary').removeClass('primary');
                $('.filter-icon.primary').removeClass('primary');
            }
        });

        axios.get('/ajax/shreports')
        .then(function(response) {
            checkCredentials(response)
            
            self.setState({
                loading_data: false,
                data: response?.data,
            })
        })
        .catch(function(error) {
            if(!("response" in error)) {
                showStatusMsg("Requested information not found");
            } else if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    render() {
        if(!this.state.loading_data)
        {
        }
        return (
            <div>
                <div className = "bkg-white-dark listviewnew">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "titlebar">
                        <div className = "titlebar-left">
                            <div className = "left">
                                <h1>SH Reports</h1>
                            </div>
                        </div>
                    </div>
                    <div className = "" style={{margin: "0 10px"}}>
                        {
                            !this.state.loading_data ?
                                <>
                                    <br /><br /><br /><br /><br /><br /><br />
                                    <div>
                                    How various data is calculated for the Stakeholder Email Reports<br />
                                    <br />
                                    Vehicle Utilization Rate:<br />
                                    - Calculated For All vehicles in the fleet during the given time period (all vehicles which have been added before the end date and terminated before the end date are included)<br />
                                    - The number of days available for each vehicle in a given period is calculated based on their available date and terminated date.<br />
                                    - Formulae = (Total Days Vehicle Out / Total Days Vehicle Available) * 100<br />
                                    <br />
                                    Vehicle Activity<br />
                                    - Formuale = (Active Vehicles / Total available Vehicles) * 100<br />
                                    <br />
                                    User Activity<br />
                                    - Formuale = (Active Users / Total Users) * 100<br />
                                    <br />
                                    Users by Location<br />
                                    - A user with access to multiple VCs will be counted as a user in each of the VC<br />
                                    - The total users count is calculated by aggregating user accesses from all VCs<br />
                                    <br />
                                    Reminders by Date and Mileage<br />
                                    - Only reminders which have been triggered and haven’t been resolved are listed<br />
                                    <br />
                                    Active Users By Location<br />
                                    - A user with access to multiple VCs will be counted as a user in each of the VC<br />
                                    - A user active in one VC will be termed as active in all other VCs<br />
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Graphs Data - Page 1</b>
                                    <br /><br />
                                    <div>Vehicle Utilization Rate: { this.state.data.last_month_utilization } - { (this.state.data.last_month_utilization > this.state.data.last_second_month_utilization ? ("Up by " + (this.state.data.last_month_utilization - this.state.data.last_second_month_utilization) + "%") : ("Down by " + (this.state.data.last_second_month_utilization - this.state.data.last_month_utilization) + "%")) }</div>
                                    <br />
                                    <div>Vehicle Activity: {Math.round((this.state.data.active_vehicles / this.state.data.available_vehicles) * 100)}%</div>
                                    <br />
                                    <div>Bookings by Locations:
                                        {
                                            this.state.data.bookings_by_locations.map((location, i) => {
                                                return (
                                                    <>
                                                        {location.vmh.Display_City} - {location.Bookings_Count}
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <br /><br />
                                    <b> User Graphs Data - Page 1</b>
                                    <br /><br />
                                    <div>New Users: { this.state.data.new_users_last_month } - { (this.state.data.new_users_last_month > this.state.data.new_users_last_second_month ? ("Up by " + (this.state.data.new_users_last_month - this.state.data.new_users_last_second_month)) : ("Down by " + (this.state.data.new_users_last_second_month - this.state.data.new_users_last_month))) }</div>
                                    <br />
                                    <div>User Activity: {Math.round(this.state.data.active_users_percentage)}% Active Users</div>
                                    <br />
                                    <div>Users by Location: 
                                        {
                                            this.state.data.users_by_locations.map((location, i) => {
                                                return (
                                                    <>
                                                        {location.vmh.Display_City} - {location.Users_Count} 
                                                    </>
                                                )
                                            })
                                        }
                                        <br/>
                                        Total Users: {this.state.data.total_users}
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Graphs Data - Page 2</b>
                                    <br /><br />
                                    <div>Vehicle Utilization:
                                        { 
                                            Array.from(new Array(12), (val, index) => index).map((index) => {
                                                return(
                                                    <>
                                                        <br />
                                                        Week {index + 1} - Utilization - {this.state.data.weekly_utilization[(index + 1)]} - Available Vehicles - {this.state.data.weekly_availability[(index + 1)]}
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Table Data - Page 2</b>
                                    <br /><br />
                                    <div>Vehicle Utilization Summary:
                                    <br /><br />
                                    Vehicles with Highest Utilization
                                    <br /><br />
                                    <table>
                                        <tr>
                                            <td>Vehicle</td>
                                            <td>Location</td>
                                            <td>Mileage (KM)</td>
                                            <td>Tier</td>
                                            <td># Bookings</td>
                                            <td>Utilization</td>
                                        </tr>
                                        {
                                            this.state.data.highest_utlization_vehicles.map((vehicle, i) => {
                                                return (
                                                    <tr>
                                                        <td>{vehicle.name} <br/> {vehicle.vin}</td>
                                                        <td>{vehicle.vmh}</td>
                                                        <td>{vehicle.km_driven}</td>
                                                        <td>{vehicle.tier}</td>
                                                        <td>{vehicle.total_bookings}</td>
                                                        <td>{vehicle.utilization}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    <br /><br />
                                    Vehicles with Lowest Utilization
                                    <br /><br />
                                    <table>
                                        <tr>
                                            <td>Vehicle</td>
                                            <td>Location</td>
                                            <td>Mileage (KM)</td>
                                            <td>Tier</td>
                                            <td># Bookings</td>
                                            <td>Utilization</td>
                                        </tr>
                                        {
                                            this.state.data.lowest_utlization_vehicles.map((vehicle, i) => {
                                                return (
                                                    <tr>
                                                        <td>{vehicle.name} <br/> {vehicle.vin}</td>
                                                        <td>{vehicle.vmh}</td>
                                                        <td>{vehicle.km_driven}</td>
                                                        <td>{vehicle.tier}</td>
                                                        <td>{vehicle.total_bookings}</td>
                                                        <td>{vehicle.utilization}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Booking Details - Page 3</b>
                                    <br /><br />
                                    <div>List of Bookings: 
                                        <table>
                                            <tr>
                                                <td>Vehicle</td>
                                                <td>User Name</td>
                                                <td>Role</td>
                                                <td>Tier</td>
                                                <td>Start Date</td>
                                                <td>End Date</td>
                                                <td># Days</td>
                                                <td>Mileage (KM)</td>
                                            </tr>
                                            {
                                                this.state.data.vehicles_and_bookings.map((vehicle, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{vehicle.Year} {vehicle.Make} {vehicle.Model} <br /> {vehicle.VIN}</td>
                                                            <td colspan="7">
                                                                <table>
                                                                    {
                                                                        vehicle.bookings.map((booking, i) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{booking.profile.First_Name} {booking.profile.Last_Name}</td>
                                                                                    <td>TBC</td>
                                                                                    <td>TBC</td>
                                                                                    <td>{ moment(booking.Start_Date ).format("MMM DD, YYYY")}</td>
                                                                                    <td>{ moment(booking.End_Date ).format("MMM DD, YYYY")}</td>
                                                                                    <td>{ (moment(booking.End_Date).diff(moment(booking.Start_Date), 'days') + 1) }</td>
                                                                                    <td>{ booking.Odometer_Pre > 0 && booking.Odometer_Post > 0 ? ((booking.Odometer_Post - booking.Odometer_Pre) + "KM") : "N/A" }</td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }
                                                                </table>
                                                            </td>
                                                            
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Reminders Data - Page 4</b>
                                    <br /><br />
                                    <div>Reminders by Date:
                                        <br /><br />
                                        <table>
                                            <tr>
                                                <td>Vehicle</td>
                                                <td>Location</td>
                                                <td>Plate</td>
                                                <td>Tier</td>
                                                <td>Type</td>
                                                <td>Date Reminder</td>
                                            </tr>
                                            {
                                                this.state.data.pending_reminders_by_date.map((reminder, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{reminder.Year} {reminder.Make} {reminder.Model} <br/> {reminder.VIN}</td>
                                                            <td>{reminder.Display_Name} {reminder.Display_City}</td>
                                                            <td>{reminder.License_Plate}</td>
                                                            <td> TBC </td>
                                                            <td>{reminder.Category}</td>
                                                            <td>{ moment(reminder.Remind_Date).format("MMM DD, YYYY") } <br /> { moment(reminder.Remind_Date).fromNow() }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <br /><br />
                                    <div>Reminders by KM:
                                        <br /><br />
                                        <table>
                                            <tr>
                                                <td>Vehicle</td>
                                                <td>Location</td>
                                                <td>Plate</td>
                                                <td>Type</td>
                                                <td>Mileage Reminder (KM)</td>
                                                <td>Current Mileage (KM)</td>
                                            </tr>
                                            {
                                                this.state.data.pending_reminders_by_km.map((reminder, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{reminder.Year} {reminder.Make} {reminder.Model} <br/> {reminder.VIN}</td>
                                                            <td>{reminder.Display_Name} {reminder.Display_City}</td>
                                                            <td>{reminder.License_Plate}</td>
                                                            <td>{reminder.Category}</td>
                                                            <td>{new Intl.NumberFormat('en-CA').format(reminder.Remind_km)} KM</td>
                                                            <td>{new Intl.NumberFormat('en-CA').format(reminder.Odometer)} KM</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <b> Vehicle Table Data - Page 5</b>
                                    <br /><br />
                                    <div>Vehicles with Highest Bookings
                                    <br /><br />
                                    <table>
                                        <tr>
                                            <td>Vehicle</td>
                                            <td>Location</td>
                                            <td>Plate</td>
                                            <td>Mileage (KM)</td>
                                            <td>Tier</td>
                                            <td>Last Booking</td>
                                            <td># Bookings</td>
                                        </tr>
                                        {
                                            this.state.data.highest_booking_vehicles.map((vehicle, i) => {
                                                return (
                                                    <tr>
                                                        <td>{vehicle.name} <br/> {vehicle.vin}</td>
                                                        <td>{vehicle.vmh}</td>
                                                        <td>{vehicle.plate}</td>
                                                        <td>{vehicle.km_driven}</td>
                                                        <td>{vehicle.tier}</td>
                                                        <td>{vehicle.last_booking_date != null ? moment(vehicle.last_booking_date).format("MMM DD, YYYY") : "N/A"}</td>
                                                        <td>{vehicle.total_bookings}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    <br /><br />
                                    Vehicles with Highest Mileage
                                    <br /><br />
                                    <table>
                                        <tr>
                                            <td>Vehicle</td>
                                            <td>Location</td>
                                            <td>Plate</td>
                                            <td>Tier</td>
                                            <td># Bookings</td>
                                            <td>Mileage (KM)</td>
                                        </tr>
                                        {
                                            this.state.data.lowest_utlization_vehicles.map((vehicle, i) => {
                                                return (
                                                    <tr>
                                                        <td>{vehicle.name} <br/> {vehicle.vin}</td>
                                                        <td>{vehicle.vmh}</td>
                                                        <td>{vehicle.plate}</td>
                                                        <td>{vehicle.tier}</td>
                                                        <td>{vehicle.total_bookings}</td>
                                                        <td>{vehicle.km_driven}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <b> Vehicle List Details - Page 6</b>
                                    <br /><br />
                                    <div>Vehicles List
                                    <br /><br />
                                    <table>
                                        <tr>
                                            <td>Vehicle</td>
                                            <td>Location</td>
                                            <td>Tier</td>
                                            <td>Last Booking</td>
                                            <td># Bookings</td>
                                            <td>Mileage (KM)</td>
                                            <td>Utilization</td>
                                        </tr>
                                        {
                                            this.state.data.vehicles_list.map((vehicle, i) => {
                                                return (
                                                    <tr>
                                                        <td>{vehicle.name} <br/> {vehicle.vin}</td>
                                                        <td>{vehicle.vmh}</td>
                                                        <td>{vehicle.tier}</td>
                                                        <td>{vehicle.last_booking_date != null ? moment(vehicle.last_booking_date).format("MMM DD, YYYY") : "N/A"}</td>
                                                        <td>{vehicle.total_bookings}</td>
                                                        <td>{vehicle.km_driven}</td>
                                                        <td>{vehicle.utilization}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <b> Users Graphs Data - Page 2</b>
                                    <br /><br />
                                    <div>Active Users By Location:
                                        {
                                            this.state.data.active_users_by_locations.map((location, i) => {
                                                return (
                                                    <>
                                                        {location.vmh.Display_City} - {location.Users_Count}
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                    <br /><br />
                                    <div>New User Summary:
                                    <table>
                                        <tr>
                                            <td>Name</td>
                                            <td>Role</td>
                                            <td>Company</td>
                                            <td>Location</td>
                                            <td>Contact Info</td>
                                            <td># Bookings</td>
                                            <td>Date Joined</td>
                                        </tr>
                                        {
                                            this.state.data.new_users.map((user, i) => {
                                                return (
                                                    <tr>
                                                        <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                        <td>{user.Title}</td>
                                                        <td>{user.Company}</td>
                                                        <td>
                                                            {
                                                                user.sh_vmh_access.map((access, i) => {
                                                                    return (
                                                                        <>
                                                                            { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </td>
                                                        <td>{user.phonenumbers.length > 0 ? user.phonenumbers[0].Number : "N/A"} <br /> {user.Email}</td>
                                                        <td>{user.bookings_made_last_three_months_count}</td>
                                                        <td>{user.sh_vmh_access[0].Created_At != null ? moment(user.sh_vmh_access[0].Created_At).format("MMM DD, YYYY") : "N/A"} <br /> {user.sh_vmh_access[0].Created_At != null ? moment(user.sh_vmh_access[0].Created_At).fromNow() : ""}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <div>Users Awaiting Approval:
                                    <table>
                                        <tr>
                                            <td>Name</td>
                                            <td>Role</td>
                                            <td>Company</td>
                                            <td>Location</td>
                                            <td>Fleet Type</td>
                                            <td>Contact Info</td>
                                            <td>Date Joined</td>
                                        </tr>
                                        {
                                            this.state.data.pending_users.map((user, i) => {
                                                return (
                                                    <tr>
                                                        <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_requests[0].tier.Rank}</td>
                                                        <td>{user.Title}</td>
                                                        <td>{user.Company}</td>
                                                        <td>
                                                            {
                                                                user.sh_requests.map((access, i) => {
                                                                    return (
                                                                        <>
                                                                            { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </td>
                                                        <td>{user.sh_requests[0].stakeholder.Category}</td>
                                                        <td>{user.phonenumbers.length > 0 ? user.phonenumbers[0].Number : "N/A"} <br /> {user.Email}</td>
                                                        <td>{user.sh_requests[0].Created_At != null ? moment(user.sh_requests[0].Created_At).format("MMM DD, YYYY") : "N/A"} <br /> {user.sh_requests[0].Created_At != null ? moment(user.sh_requests[0].Created_At).fromNow() : ""}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <b> Users Bookings Details - Page 3</b>
                                    <br /><br />
                                    <div>List of Bookings: 
                                        <table>
                                            <tr>
                                                <td>User</td>
                                                <td>Vehicle Name</td>
                                                <td>Location</td>
                                                <td>Start Date</td>
                                                <td>End Date</td>
                                                <td># Days</td>
                                                <td>Mileage (KM)</td>
                                            </tr>
                                            {
                                                this.state.data.user_bookings.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td colspan="7">
                                                                <table>
                                                                    {
                                                                        user.bookings.map((booking, i) => {
                                                                            return (
                                                                                <tr>
                                                                                    <td>{booking.vehicle.Year} {booking.vehicle.Make} {booking.vehicle.Model} <br /> {booking.vehicle.VIN}</td>
                                                                                    <td>{booking.vmh.Display_Name} {booking.vmh.Display_City}</td>
                                                                                    <td>{ moment(booking.Start_Date ).format("MMM DD, YYYY")}</td>
                                                                                    <td>{ moment(booking.End_Date ).format("MMM DD, YYYY")}</td>
                                                                                    <td>{ (moment(booking.End_Date).diff(moment(booking.Start_Date), 'days') + 1) }</td>
                                                                                    <td>{ booking.Odometer_Pre > 0 && booking.Odometer_Post > 0 ? ((booking.Odometer_Post - booking.Odometer_Pre) + "KM") : "N/A" }</td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    }
                                                                </table>
                                                            </td>
                                                            
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <b> Monthly User Summary - Page 4</b>
                                    <br /><br />
                                    <div>Most Active Users:
                                    <table>
                                        <tr>
                                            <td>Name</td>
                                            <td>Role</td>
                                            <td>Company</td>
                                            <td>Location</td>
                                            <td>Days Booked</td>
                                            <td>Last Booking</td>
                                            <td># Bookings</td>
                                        </tr>
                                        {
                                            this.state.data.most_active_users.map((user, i) => {
                                                return (
                                                    <tr>
                                                        <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                        <td>{user.Title}</td>
                                                        <td>{user.Company}</td>
                                                        <td>
                                                            {
                                                                user.sh_vmh_access.map((access, i) => {
                                                                    return (
                                                                        <>
                                                                            { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </td>
                                                        <td>{user.days_booked}</td>
                                                        <td>{user.last_booking != null ? moment(user.last_booking.End_Date).format("MMM DD, YYYY") : "N/A"} <br /> {user.last_booking != null ? moment(user.last_booking.End_Date).fromNow() : ""}</td>
                                                        <td>{user.bookings_made_last_three_months_count}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <div>Least Active Users:
                                    <table>
                                        <tr>
                                            <td>Name</td>
                                            <td>Role</td>
                                            <td>Company</td>
                                            <td>Location</td>
                                            <td>Days Booked</td>
                                            <td>Last Booking</td>
                                            <td># Bookings</td>
                                        </tr>
                                        {
                                            this.state.data.least_active_users.map((user, i) => {
                                                return (
                                                    <tr>
                                                        <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                        <td>{user.Title}</td>
                                                        <td>{user.Company}</td>
                                                        <td>
                                                            {
                                                                user.sh_vmh_access.map((access, i) => {
                                                                    return (
                                                                        <>
                                                                            { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </td>
                                                        <td>{user.last_booking != null ? moment(user.last_booking.End_Date).format("MMM DD, YYYY") : "N/A"} <br /> {user.last_booking != null ? moment(user.last_booking.End_Date).fromNow() : ""}</td>
                                                        <td>{user.bookings_made_last_three_months_count}</td>
                                                        <td>{user.phonenumbers.length > 0 ? user.phonenumbers[0].Number : "N/A"} <br /> {user.Email}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    </div>
                                    <br /><br />
                                    <div>Inactive Users:
                                        <table>
                                            <tr>
                                                <td>Name</td>
                                                <td>Role</td>
                                                <td>Company</td>
                                                <td>Location</td>
                                                <td>Last Booking</td>
                                                <td>Contact Info</td>
                                            </tr>
                                            {
                                                this.state.data.inactive_users.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td>{user.Title}</td>
                                                            <td>{user.Company}</td>
                                                            <td>
                                                                {
                                                                    user.sh_vmh_access.map((access, i) => {
                                                                        return (
                                                                            <>
                                                                                { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                            <td>{user.last_booking != null ? moment(user.last_booking.End_Date).format("MMM DD, YYYY") : "N/A"} <br /> {user.last_booking != null ? moment(user.last_booking.End_Date).fromNow() : ""}</td>
                                                            <td>{user.phonenumbers.length > 0 ? user.phonenumbers[0].Number : "N/A"} <br /> {user.Email}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <b> Submission Details - Page 5</b>
                                    <br /><br />
                                    <div>List of Submissions:
                                        <table>
                                            <tr>
                                                <td>User Name</td>
                                                <td>Submission Name</td>
                                                <td>Vehicle</td>
                                                <td>End of Booking</td>
                                                <td>Submission Date</td>
                                                <td>Tone</td>
                                            </tr>
                                            {
                                                this.state.data.submissions_last_month.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td colspan="7">
                                                                <table>
                                                                    {
                                                                        user.bookings.map((booking, i) => {
                                                                            return (
                                                                                booking.media ?
                                                                                    <tr>
                                                                                        <td>{booking.media.Title} <br /> {booking.media.Link}</td>
                                                                                        <td>{booking.vehicle.Year} {booking.vehicle.Make} {booking.vehicle.Model} <br /> {booking.vehicle.VIN}</td>
                                                                                        <td>{ moment(booking.End_Date ).format("MMM DD, YYYY")}</td>
                                                                                        <td>{ moment(booking.media.created_at ).format("MMM DD, YYYY")}</td>
                                                                                        <td>{ booking.media.Rating ? booking.media.Rating : "N/A" }</td>
                                                                                    </tr>
                                                                                :
                                                                                    null
                                                                            );
                                                                        })
                                                                    }
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <b> User Media Submission Summary - Page 5</b>
                                    <br /><br />
                                    <div>Users with Highest # of Submissions (Top 3):
                                        <table>
                                            <tr>
                                                <td>Name</td>
                                                <td>Role</td>
                                                <td>Location</td>
                                                <td># Bookings</td>
                                                <td># Submissions</td>
                                                <td># Missed Submissions</td>
                                            </tr>
                                            {
                                                this.state.data.highest_submissions_users.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td>{ user.sh_vmh_access[0].User_Role }</td>
                                                            <td>
                                                                {
                                                                    user.sh_vmh_access.map((access, i) => {
                                                                        return (
                                                                            <>
                                                                                { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                            <td>{ user.bookings_made_last_three_months_count } </td>
                                                            <td>{ user.media_count }</td>
                                                            <td>{ (user.bookings_made_last_three_months_count - user.media_count) }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <div>Users with Lowest # of Submissions (Top 3):
                                        <table>
                                            <tr>
                                                <td>Name</td>
                                                <td>Role</td>
                                                <td>Location</td>
                                                <td># Bookings</td>
                                                <td># Submissions</td>
                                                <td># Missed Submissions</td>
                                            </tr>
                                            {
                                                this.state.data.lowest_submissions_users.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td>{ user.sh_vmh_access[0].User_Role }</td>
                                                            <td>
                                                                {
                                                                    user.sh_vmh_access.map((access, i) => {
                                                                        return (
                                                                            <>
                                                                                { access.vmh.Display_Name } { access.vmh.Display_City }
                                                                            </>
                                                                        )
                                                                    })
                                                                }
                                                            </td>
                                                            <td>{ user.bookings_made_last_three_months_count } </td>
                                                            <td>{ user.media_count }</td>
                                                            <td>{ (user.bookings_made_last_three_months_count - user.media_count) }</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                    <br /><br />
                                    <div>Outstanding Submissions:
                                        <table>
                                            <tr>
                                                <td>Name</td>
                                                <td>Role</td>
                                                <td>Location</td>
                                                <td>Vehicle</td>
                                                <td>End of Booking</td>
                                                <td>Contact Info</td>
                                            </tr>
                                            {
                                                this.state.data.outstanding_submissions.map((user, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{user.First_Name} {user.Last_Name}<br/> {user.sh_vmh_access[0].tier.Rank}</td>
                                                            <td>{ user.sh_vmh_access[0].User_Role }</td>
                                                            <td colspan="2">
                                                                <table>
                                                                    {
                                                                        user.bookings.map((booking, i) => {
                                                                            return (
                                                                                booking.media == null ?
                                                                                    <tr>
                                                                                        <td>{booking.vehicle.Year} {booking.vehicle.Make} {booking.vehicle.Model} <br /> {booking.vehicle.VIN}</td>
                                                                                        <td>{ moment(booking.End_Date ).format("MMM DD, YYYY")} <br /> {booking.End_Date != null ? moment(booking.End_Date).fromNow() : ""}</td>
                                                                                    </tr>
                                                                                :
                                                                                    null
                                                                            );
                                                                        })
                                                                    }
                                                                </table>
                                                            </td>
                                                            <td>{user.phonenumbers.length > 0 ? user.phonenumbers[0].Number : "N/A"} <br /> {user.Email}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </table>
                                    </div>
                                </>
                            :
                                null
                        }
                    </div>
                </div>
                <ModalRoutes match={this.props.match} history={this.props.history}/>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(SHReports)